/** @format */

import template from './gb-bidding-item-amount-label.html';
import './gb-bidding-item-amount-label.scss';

export const GbBiddingItemAmountLabelComponent = {
    template,
    bindings: {
        biddingItem: '<',
        winningBid: '<?',
    },
    controller: class GbBiddingItemAmountLabelComponent {
        constructor() {
            'ngInject';
        }
    },
};
